import { render, staticRenderFns } from "./CreateSosDialog.vue?vue&type=template&id=4d9ce91c&"
import script from "./CreateSosDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateSosDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports